import React, { Component, useState, useEffect, bootstrap } from 'react';
import { connect } from 'react-redux'
import { addToCart, addToOrders } from './reducers/cartReducer'
import { removeItem } from './reducers/cartReducer'
import { fetchData } from './reducers/cartReducer'
import Navbar from './Navbar'
import Modal from 'react-bootstrap/Modal'
import M from 'materialize-css'
import Button from 'react-bootstrap/Modal'
import Item1 from '../images/SCONES.jpg'
import { Link } from 'react-router-dom'
import swal from 'sweetalert';
import Dropdown from 'react-bootstrap/Dropdown'
import DropdownButton from 'react-bootstrap/DropdownButton'
import { Container, Row, Col } from 'reactstrap';



const Toppings = (props) => {
    let choiceType = []

    if (props.choices !== "null") {


        for (const [key, value] of Object.entries(JSON.parse(props.choices))) {
            choiceType.push(key)

        }
        return (
            <div>

                {choiceType.map((choice) => <div>

                    <div class="tophead card-panel blue lighten-2" onClick={() => { props.handleShow(choice) }}><label><input type="checkbox"

                        checked={props.showSelected == choice || props.topselected.filter((top) => top.subCategory == choice).length >= 1 ? true : false} /><span style={{ color: "Black" }}><b>{choice}</b> </span></label>
                        {props.topselected.map((top) => top.subCategory == choice ? " - " + top.title : "")}</div>

                    {props.items.map((t) => (t.category === "Choice") && t.subCategory == choice &&
                        props.choices.indexOf(t.id) > -1 && props.showSelected == choice
                        ? <label><input type="radio" name={t.subCategory} checked={props.topselected.filter((top) => top.id == t.id).length == 1 ? true : false} onClick={() => { props.handleClick(t.id, props.baseid, t.category, t.subCategory) }} value={t.id} /> <span style={{ color: "Black" }}>{t.title} </span><br />
                        </label> : "")}

                    {props.customMessage === "1" ?
                        <div >
                            <span style={{ color: "Black" }}><b>Custom Message: </b></span>
                            <textarea maxlength="200" rows="5" type="textarea" name="comment" id="comment" onChange={() => { props.handleClick(0, props.baseid, document.getElementById("comment").value, "addComment") }} class="textarea" id="comment"></textarea >
                        </div> : ""}


                </div>)}


            </div>
        )
    }
    else {
        return (
            <div>
                { props.customMessage === "1" ?
                    <div >
                        <span style={{ color: "Black" }}><b>Custom Message:</b></span>
                        <textarea maxlength="200" rows="5" type="textarea" name="comment" id="comment" onChange={() => { props.handleClick(0, props.baseid, document.getElementById("comment").value, "addComment") }} class="textarea" id="comment"></textarea >
                    </div> : ""}
            </div>
        )

    }


}




class Home extends Component {
    constructor(props) {
        super(props)
        this.state = {
            itemSelected: "",
            showSelected: ""
        }
    }

    componentDidMount() {

        if (this.props.items.length == 0) {
            this.props.fetchData();
        }

    }



    handleRemoveClick = (id, baseid) => {
        this.props.removeItem(id + "_" + baseid);

        this.props.items.find(item => item.id === baseid).quantity = 0
        this.props.items.find(item => item.id === baseid).topping = []
        this.forceUpdate(); //relad the component
    }

    handleChangeClick = (id, baseid) => {
        if (id !== baseid)//topping
        {
            //remove the last  beverage
            this.props.items.find(item => item.id === baseid).topping = [];
            this.props.addToCart(id + "_" + baseid);
        }

        this.setState({ total: 1 })
        this.forceUpdate();
    }


    handleShowHide = (value) => {
        this.setState({ showSelected: value })
    }

    handleClick = (id, baseid, category, subcategory) => {


        if (id !== baseid)//topping
        {
            if (id != 0 && subcategory != "addComment") {
                var pizzaselected = false;
                var selected = false;
                pizzaselected = this.props.items.find(t => t.id === baseid).quantity > 0;
                if (!pizzaselected) {
                    swal("Add the main item first");
                    return;
                }

                this.props.addToCart(id + "_" + baseid + ":" + category + "*" + subcategory);
            } else { // addComment\
                this.props.addToCart(id + "_" + baseid + ":" + category + "*" + subcategory);

            }
        }
        else //base item
        {
            if (subcategory == "remove") {
                this.props.addToCart(id + "_" + baseid + ":" + subcategory + "*");

                let changedIteme = this.props.items.find(x => x.id == baseid)

                if (changedIteme.quantity < 1) {
                    this.setState({ itemSelected: "" })
                }
                //

            } else {
                this.props.addToCart(id + "_" + baseid);
                if (category == "Base") {
                    this.setState({ itemSelected: id })
                }
            }
        }
        this.forceUpdate();

    }


    handleAddToOrder = (item) => {
        this.props.addToOrders(item);
        this.handleRemoveClick(item.id, item.id)
        this.setState({ itemSelected: "" })
        this.forceUpdate();
        this.props.history.push("/cart")
    }



    render() {



        let itemList = this.props.items.map(item => {


            if (item.category === "Base" && item.mainCategory == this.props.mainCategory) {
                if (item.topping === "[]") {
                    item.topping = [];
                }

                if (this.state.itemSelected == "") {

                    return (

                        <div className="card" key={item.id}>

                            <div className="card-image">
                              {item.img != null ? <img src={item.img} onError={(e) => { e.target.onerror = null; e.target.src = "" }} /> : ""}  
                                   {/* <img src={Item1} alt={item.title} /> */}
                                <span to="/" className="btn-floating halfway-fab waves-effect waves red addButton" onClick={() => { this.handleClick(item.id, item.baseid, item.category) }}><i className="material-icons">add</i></span>
                                {item.quantity > 0 ?
                                    <span className="btn-floating  waves-effect waves red removeButton" onClick={() => { this.handleClick(item.id, item.baseid, item.category, "remove") }}><i className="material-icons">remove</i></span> : ""
                                }
                            </div>

                            <div className="card-content descBox1">
                                <span className="card-title">{item.title} </span>
                                <p>{item.description}</p>
                                <p><b>${item.price}</b></p>


                            </div>
                        </div>
                    )
                }
                else {
                    if (this.state.itemSelected == item.id) {
                        return (

                            <div className="card" key={item.id}>

                                <div className="card-image">
                                     {item.img != null ? <img src={item.img} onError={(e) => { e.target.onerror = null; e.target.src = "" }} /> : ""}  

                                    {/* <img src={Item1} alt={item.title} />*/}
                                    <span to="/" className="btn-floating halfway-fab waves-effect waves red addButton" onClick={() => { this.handleClick(item.id, item.baseid, item.category) }}><i className="material-icons">add</i></span>
                                    {item.quantity > 0 ?
                                        <span className="btn-floating halfway  waves-effect waves red removeButton" style={{ top: "20px;" }} onClick={() => { this.handleClick(item.id, item.baseid, item.category, "remove") }}><i className="material-icons">remove</i></span> : ""
                                    }
                                </div>

                                <div className="card-content descBox">
                                    <span className="card-title">{item.title}</span>
                                    <p>{item.description}</p>
                                    <p><b>Price: ${item.price}</b></p>
                                    <p><b>Quantity: {item.quantity}</b></p>
                                    {item.quantity > 0 && item.title !== "Beverage" ? <div > <Toppings baseid={item.id} topselected={item.topping} invItems={item.inv_toppingID} choices={item.inv_choices}
                                        items={this.props.items} customMessage={item.customMessage} handleShow={this.handleShowHide} showSelected={this.state.showSelected} handleRemoveClick={this.handleRemoveClick}
                                        handleClick={this.handleClick} handleAddToOrder={this.handleAddToOrder} />


                                    </div> : ""}


                                    {(item.topping.length > 0 && item.quantity > 0) || (item.quantity > 0 && item.inv_toppingID == "null" && item.inv_choices == "null"
                                        && item.inv_condiments == "null" && item.inv_sides == "null") ? <button className='waves-effect waves-light btn green add' onClick={() => { this.handleAddToOrder(item) }}>Add to Cart</button> : ""}


                                </div>
                            </div>
                        )
                    }
                }
            }
        })

        return (
            <div>
                <Navbar isAuthed={true} />
                <div className="container"><br /><br />


                    {this.state.itemSelected == "" && this.props.mainCategory ? <h5 className="center">SELECT {this.props.mainCategory}</h5> : <br />}
                    <Link name="mainMenu" class="btn mainMenu " to={{
                        pathname: '/',
                        state: {
                            flag: true
                        }
                    }}><b> {"<"} Main Menu</b> </Link>
                    {this.props.orders.length > 0 ?
                        <Link className="waves-effect waves-light btn float-right " style={{ float: "right" }} to="/cart">View cart </Link> : ""}<br />
                    <div className="submenu box">

                        {itemList}
                    </div>

                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {

        items: state.items,
        orders: state.orders,
        mainCategory: state.mainCategory
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        fetchData: () => { dispatch(fetchData()) },
        addToOrders: (orderData) => { dispatch(addToOrders(orderData)) },
        addToCart: (id) => { dispatch(addToCart(id)) },
        removeItem: (id) => { dispatch(removeItem(id)) }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home)